import { useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

import { ATSPrincipalAppNavbarTestIds } from 'data-testids/ATS';
import { Box, IconButton, List, ListItem, Typography, useTheme } from '@mui/material';
import {
  DrawerHeader,
  ToolbarHeader,
} from 'features/TabbedJobView/TabNavigation/components/styles';
import { MobileToolbar, TabDrawer } from '../styles';
import { getTopPrincipalMobileNavigationData } from '../data';
import auth from 'utils/auth';
import CloseIcon from '@mui/icons-material/Close';
import logo from '../assets/logo.jpg';
import MenuIcon from '@mui/icons-material/Menu';
import mobileLogo from '../assets/mobile-logo.svg';
import { TextButton } from 'sharedComponents/Buttons';

export const PrincipalMobileNavigation = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const history = useHistory();
  const user = auth.getUser();
  const theme = useTheme();

  const toggleDrawer = () => setMobileOpen(!mobileOpen);
  const isAtCandidatesList = useRouteMatch('/principal/candidates')?.isExact;

  const getHeaderText = () => {
    if (isAtCandidatesList) {
      return 'Candidates';
    } else {
      return 'Connect Hiring Requests';
    }
  };

  const onTabClick = (route: string): void => {
    toggleDrawer();
    history.push(route);
  };

  const onHomeClick = () => {
    toggleDrawer();
    history.push('/principal/candidates');
  };

  const handleLogOut = () => {
    setMobileOpen(false);
    auth.logout().then(() => history.push('/login'));
  };

  const handleReleaseHijack = () => {
    auth.handleReleaseHijack();
    setMobileOpen(false);
  };

  const topPrincipalMobileNavigationData = getTopPrincipalMobileNavigationData(
    auth.hasConnectIntegrationModule()
  );

  return (
    <MobileToolbar
      data-testid={ATSPrincipalAppNavbarTestIds.MOBILE_NAVBAR}
      variant="dense"
      sx={{ backgroundColor: theme.palette.primary.contrastText }}
    >
      <ToolbarHeader>
        <TextButton onClick={() => history.push('/principal/candidates')}>
          <img src={mobileLogo} />
        </TextButton>
        <Typography variant="h6" data-testid={ATSPrincipalAppNavbarTestIds.HEADER}>
          {getHeaderText()}
        </Typography>
        <IconButton
          color="inherit"
          data-testid={ATSPrincipalAppNavbarTestIds.HAMBURGER}
          edge="start"
          onClick={toggleDrawer}
        >
          <MenuIcon />
        </IconButton>
      </ToolbarHeader>

      <TabDrawer anchor="left" open={mobileOpen} onClose={toggleDrawer}>
        <List>
          <DrawerHeader>
            <IconButton
              data-testid={ATSPrincipalAppNavbarTestIds.CLOSE_BUTTON}
              onClick={onHomeClick}
            >
              <img src={logo} width={'88px'} height="24px" />
            </IconButton>
            <IconButton onClick={toggleDrawer}>
              <CloseIcon />
            </IconButton>
          </DrawerHeader>

          <Box sx={{ paddingTop: theme.spacing(1) }}>
            {topPrincipalMobileNavigationData.map((item, index) => (
              <ListItem
                data-testid={`${ATSPrincipalAppNavbarTestIds.MOBILE_LIST_ITEM}-${index}`}
                sx={{
                  cursor: 'pointer',
                  display: item.isVisible ? 'block' : 'none',
                }}
                key={index}
                onClick={() => onTabClick(item.route)}
                value={item.value}
              >
                {item.label}
              </ListItem>
            ))}
            <ListItem
              sx={{
                fontSize: theme.typography.body3.fontSize,
                fontWeight: theme.typography.fontWeightMediumBold,
                letterSpacing: '0.1px',
                borderTop: `1px solid ${theme.palette.border.main}`,
              }}
            >
              {user.name}
            </ListItem>
            {user.is_hijacked && <ListItem onClick={handleReleaseHijack}>Release hijack</ListItem>}
            <ListItem onClick={handleLogOut}>Log Out</ListItem>
          </Box>
        </List>
      </TabDrawer>
    </MobileToolbar>
  );
};
